import React, { useEffect } from 'react';
import { getUserData } from '../../helpers';

// Zoho Sales Iq Script:
const useScript = (url, widgetCode) => {
  useEffect(() => {
    const script = document.createElement('script');
    script.setAttribute('type', 'text/javascript');

    const code = `var $zoho=$zoho || {};$zoho.salesiq = $zoho.salesiq || {widgetcode: "${widgetCode}", values:{},ready:function(){}};var d=document;s=d.createElement("script");s.type="text/javascript";s.id="zsiqscript";s.defer=true;s.src="${url}";t=d.getElementsByTagName("script")[0];t.parentNode.insertBefore(s,t);d.innerHTML = "<div id='zsiqwidget'></div>";`;
    const userEmail = getUserData('email') || '';
    const userFirstName = getUserData('firstName') || '';
    const userId = getUserData('_id') || '';

    const code1 = `$zoho.salesiq.ready=function()
    {
       $zoho.salesiq.visitor.id("${userId}");
       $zoho.salesiq.visitor.name("${userFirstName}");
       $zoho.salesiq.visitor.email("${userEmail}");
       
    }`;
    script.appendChild(document.createTextNode(code));
    script.appendChild(document.createTextNode(code1));
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, [url]);
};

export default function SalesIQ() {
  return (
    <>
      {useScript(
        'https://salesiq.zoho.com/widget',
        '0ce4a126ee761f7bb522a59fb05652afc94601567a8753e5fe47b52e3cde3874'
      )}
    </>
  );
}
